export default {
  EN: 'en',
  AL: 'al',
};
